import { CardBrand, InitiatePayNowResponse, Money, PaymentCardDetails, PaymentType } from '@afterpay/types'
import { DeviceDetails } from '../..'
import { PaymentStatus, PaymentSource, PaymentMethod, PaymentMethodType } from '../../payments/types'
import { OrderMerchant, OrderChannel } from '../ordertransactions/types'

export enum OrderBy {
  ORDER_NUMBER = 'orderNumber',
  DUE_DATE = 'dueDate',
  AMOUNT = 'amount',
  ORDER_DATE = 'orderDate',
}

export interface PaymentSchedule {
  id: number
  amount: Money
  amountWithFees: Money
  amountOwed: Money
  amountPayable?: Money
  refundAmount: Money
  orderFee: Money
  owedFee: Money
  paymentDate: number
  // it is being deprecated, please avoid using it
  paymentStatus: PaymentStatus
  status: PaymentStatus
  paymentType: PaymentType
  paymentMethod: PaymentMethod
  paymentSource: PaymentSource
  installmentSequence: number
  installmentDueDate: string
  originalInstallmentDueDate: string
}

export interface PaymentScheduleDueResult {
  id: number
  installmentsCount: number
  orderDateTime: string
  orderNumber: string
  orderAmount: Money
  orderFee: Money
  price: Money
  merchant: OrderMerchant
  orderChannel: OrderChannel
  paymentSchedule: PaymentSchedule
  paymentUpFront: boolean
  isInstallmentLastAndOwed?: boolean
  clearpayPartiallyMigrated?: boolean // TODO: this is a temporal property for european active loan migration, will be removed when migration is completed
  openRegZDispute?: boolean
}

export interface PaymentScheduleDueResponse {
  totalResults: number
  offset: number
  limit: number
  results: PaymentScheduleDueResult[]
}
export interface OverduePaymentSchedule {
  amount: Money
  id: number
  installmentDueDate: string
  lateFee: Money
  merchantDisplayName: string
  orderNumber: number
  paymentScheduleInstallmentSequence: number
}
export interface OverduePaymentResponse {
  enabledCardTypes: CardBrand[]
  overduePaymentSchedules: OverduePaymentSchedule[]
  totalLateFee: Money
  totalAmount: Money
}

export interface InitiateInstallmentPaymentResponse extends InitiatePayNowResponse {}
export interface InitiateInstallmentPaymentRequest {
  paymentScheduleIds: number[]
}
export interface InitiatePayNowRequest {
  paymentScheduleId: string
  deviceDetails: DeviceDetails
}
export interface ConfirmPayNowRequest {
  traceId: string
  storeToken: boolean
  paymentMethodId?: number
  paymentMethodType: PaymentMethodType
  // TODO: investigate if applepay needs paymentSourceId prop
}
export interface ConfirmPayNowResponse {
  prePaidCard: boolean
  paymentScheduleIdSet: number[]
}

export const isPaymentScheduleCard = (payment?: any): payment is PaymentCardDetails => {
  return typeof payment === 'object' && 'type' in payment && 'cardBrand' in payment
}

export const isOverduePaymentResponse = (input?: any): input is OverduePaymentResponse =>
  typeof input === 'object' &&
  input !== null &&
  'overduePaymentSchedules' in input &&
  'enabledCardTypes' in input &&
  'totalLateFee' in input &&
  'totalAmount' in input
